import { AxiosError } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from '../../config'
import { FetchSectionsResponse } from '../typings/conversations'
import { captureException } from '../utils/sentry'

const logErrorHandler = (error: AxiosError) => {
  captureException(error, {
    tags: { url: window.location.href }
  })
}

const responseErrorHandlers = [logErrorHandler]

interface PatchOperation {
  operation: string
  property: string
  value: any
}

interface SectionNotificationSetting {
  allNotificationsForSubscriptionEnabled: boolean
  subscriptionId: string
}

export const AccountActivityApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNT_ACTIVITY_API,
    timeout: 5000
  },
  responseErrorHandlers
})

export const CustomerApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API
  },
  responseErrorHandlers
})

export const ConversationApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API
  },
  responseErrorHandlers
})

export const InboxApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INBOX_API
  },
  responseErrorHandlers
})

export const MessagingApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MESSAGING_API
  },
  responseErrorHandlers
})

export const patchUserProperties = (
  userId: number,
  patchOperation: PatchOperation[]
): Promise<any> => CustomerApi.patch(`/users/${userId}/properties2`, patchOperation)

export const patchNotificationsBySection = async (
  subscriptions: Record<string, SectionNotificationSetting>
): Promise<void> => {
  const res = await MessagingApi.put('/notifications/settings/subscriptions', { subscriptions })
  return res.data
}

export const getNotificationsBySection = async (): Promise<Record<
  string,
  SectionNotificationSetting
>> => {
  const res = await MessagingApi.get('/notifications/settings/subscriptions')
  return res.data.subscriptions
}

export const fetchConversationSections = async (): Promise<FetchSectionsResponse> => {
  const res = await InboxApi.get('/sections/v2')
  return res.data
}